if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

var CURRENT_VIDEO;
var WATCHING_VIDEO = false;

//SAVE CURRENT VIDEO SRC TO CURRENT_VIDEO ELEMENT
AFRAME.registerComponent('video-controls', {
  schema: {
    videoSrcURL: {
      type: 'string'
    }
  },
  init: function () {
    var videoSrcURL = this.data.videoSrcURL;
    var videoElement = document.querySelector(videoSrcURL);

    //Click Platform -> Hide Video -> Set video Src -> Position Video
    this.el.addEventListener('click', function (event) {
      CURRENT_VIDEO = document.querySelector(videoElement.attributes.src.value);
      console.log('video-controls component CURRENT_VIDEO: ' + CURRENT_VIDEO, "WATCHING_VIDEO:", WATCHING_VIDEO);

      vidplay();
    });
  }
});


function hideVideos() {
  var videoElementArray = document.querySelectorAll("a-video");

  videoElementArray.forEach(function (vidElement) {

    // Set visibility of video
    vidElement.setAttribute('visible', false);
  })
  
  //Reset timing of current video when hidden.
  CURRENT_VIDEO.currentTime = 0;
}


//PLAY CURRENT_VIDEO (called at bottom of index.html when <body>.click())
function vidplay() {
  var video = CURRENT_VIDEO;
  console.log('CURRENT_VIDEO: ' + CURRENT_VIDEO);

  if (video.paused) {
    var playPromise = video.play();

    // In browsers that don’t yet support this functionality,
    // playPromise won’t be defined.
    if (playPromise !== undefined) {
      playPromise.then(function () {
        // Automatic playback started!
      }).catch(function (error) {
        // Automatic playback failed.
        // Show a UI element to let the user manually start playback.
        console.log(error)
      });
    }
  } else {
    video.pause();
  }
}

// //
// function setVideoVisibilityTrue(videoElement) {
//   videoElement.setAttribute('visible', true);
// }

//WATCHING VIDEO COMPONENT
AFRAME.registerComponent('watching-video', {
  init: function () {

    this.el.addEventListener('mouseenter', function (event) {
      WATCHING_VIDEO = true;
      console.log("WATCHING_VIDEO = true");
    });

    this.el.addEventListener('mouseleave', function (event) {
      WATCHING_VIDEO = false;
      console.log("WATCHING_VIDEO = false");
    });
  }
});



// WEBPACK FOOTER //
// ./src/aframe/components/video-controls.js